module.exports = __webpack_public_path__ + "img/waiting-list.5caaee56.png";